import React from 'react';

import { BaseInputProps } from './interfaces';
import { Wrapper, ErrorLabel, HintLabel, Label, LinkLabel, Input } from './styled';

export const BaseInput = React.forwardRef<HTMLInputElement, BaseInputProps>(function BaseInputField(
  {
    name,
    label = '',
    ariaLabel = '',
    type = 'text',
    linkText,
    hint,
    children,
    error,
    labelProps,
    errorLabelProps,
    ...props
  },
  ref
) {
  return (
    <Wrapper>
      <Label htmlFor={name} {...labelProps}>
        {labelProps?.children || label}
      </Label>
      <Input
        name={name}
        type={type}
        aria-label={ariaLabel || label}
        aria-invalid={!!error}
        {...props}
        ref={ref}
      />
      {children}
      {!!error && <ErrorLabel {...errorLabelProps}>{error}</ErrorLabel>}
      {hint && <HintLabel>{hint}</HintLabel>}
      {linkText && <LinkLabel as='button'>{linkText}</LinkLabel>}
    </Wrapper>
  );
});

export default BaseInput;
